// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 116) return "static/chunks/116-1d5b070cbcaeb011.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"779":"9866d957509050c9","801":"27d5b9851759f156"}[chunkId] + ".js";
};